import React, { useState } from 'react'

import SectionContainer from 'components/atoms/SectionContainer'
import Container from 'components/atoms/Container'
import Typography from 'components/atoms/Typography'
import FAQ from 'components/molecules/FAQ'

import faqData from './faqData.json'

const AptitudeFAQ = () => {
  const initialState = () => faqData.map((faq, idx) => ({
    ...faq,
    active: idx === 0,
    id: idx,
    answer: <Typography component="p" variant="body">{ faq.answer }</Typography>,
  }))
  const [faqs, setFaqs] = useState(initialState())

  const toggleAnswer = (id) => {
    const newFaqs = faqs.map(faq => (
        faq.id === id ? { ...faq, active: !faq.active } : { ...faq, active: false }
      )
    )
    setFaqs(newFaqs)
  }

  return (
    <div className="aptitude-faq">
      <SectionContainer
        paddingTop={120}
        paddingBottom={120}
        backgroundColor="transparent"
      >
        <Container>
          <Typography component="h2" variant="title" className="text-variant-title-sm text-center">
            Pertanyaan Seputar Tes Minat Bakat
          </Typography>
        </Container>
        <Container mobileFull>
          {
            faqs.map(faq => (
              <FAQ
                question={faq.question}
                answer={faq.answer}
                active={faq.active}
                key={`apt-faq-itm-${faq.id}`}
                onClick={() => toggleAnswer(faq.id)}
              />
            ))
          }
        </Container>
      </SectionContainer>
    </div>
  )
}

export default AptitudeFAQ
